import { _ as s } from "./index.es376.js";
import { _ as o } from "./index.es377.js";
import { _ as r } from "./index.es378.js";
import { _ } from "./index.es379.js";
import { _ as p } from "./index.es380.js";
import { _ as c } from "./index.es381.js";
var i = s, k = o, m = r, f = _, l = p, h = c;
function t(a) {
  var e = this.__data__ = new i(a);
  this.size = e.size;
}
t.prototype.clear = k;
t.prototype.delete = m;
t.prototype.get = f;
t.prototype.has = l;
t.prototype.set = h;
var z = t;
export {
  z as _
};
//# sourceMappingURL=index.es251.js.map
